import { createFileRoute } from "@tanstack/react-router";
import guideOgImage from "@/assets/guides/stb-ram-storage-og.jpg";
import { StbRamStorageGuidePage } from "@/components/guides/StbRamStorageGuidePage";
import { stbRamStorageGuideSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/guides/stb-ram-and-storage")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) =>
    stbRamStorageGuideSeo(loaderData?.href ?? "/guides/stb-ram-and-storage", guideOgImage),
  component: StbRamStorageGuidePage,
});
